import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';

const routes = {
  filter: '/contract-employment/contract-collection/filter'
};

export interface ContractCollectionFilterRequest {
  mohaUuid: string;
  nameOrCodePersonal: string;
  nameOrCodeContract: string;
  statusMoha: number | null;
  /** Backend currently requires this field to be null. */
  statusContractCollection: number | null;
  page: number;
  pageSize: number;
}

export interface ContractCollectionDocumentResponse {
  id: string;
  nameAndCode: string;
  fullName: string;
  certificateNo: string;
  mohaStatus: number;
  mohaUuid: string;
  customerCode?: string;
  isCheckStandardized?: boolean;
}

export interface ContractCollectionResponse {
  id: string;
  nameAndCode: string;
  fullName: string;
  certificateNo: string;
  mohaStatusFinal: number;
  mohaUuid: string;
  customerCode?: string;
  contractAppendixItemDTOS: ContractCollectionDocumentResponse[];
}

@Injectable({providedIn: 'root'})
export class ViewDossierListService {
  constructor(private apiService: ApiService) {}

  filter(request: ContractCollectionFilterRequest): Observable<any> {
    return this.apiService.post(routes.filter, request);
  }
}
